// @ts-nocheck
import { YStack, XStack, Text } from 'tamagui';
import { GridBand } from './GridBand';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * A liveness signal. A portfolio site with no dated entries reads as abandoned,
 * which is the specific doubt a solo-founder company has to overcome.
 *
 * Every entry must be something actually shipped, and stale entries are worse
 * than none — a "recently" section whose newest item is six months old says the
 * opposite of what it is here to say. Keep four, prune rather than accumulate.
 */
const entries = [
  {
    date: 'Aug 2026',
    product: 'Statio',
    title: 'Self-serve capacity',
    body: 'Buy additional hosted MCP servers and turn on usage overage from the billing page, with a spend cap you set.',
  },
  {
    date: 'Aug 2026',
    product: 'Statio',
    title: 'Per-tool access policies',
    body: 'Permissions granted per tool rather than per server, enforced at the gateway on every request.',
  },
  {
    date: 'Jul 2026',
    product: 'Platform',
    title: 'Shared billing and RBAC in production',
    body: 'Identity, organizations, permissions, and Stripe billing serving their second product.',
  },
  {
    date: 'Jul 2026',
    product: 'Statio',
    title: 'Fleet MCP discovery',
    body: 'Find every MCP server installed across a team — without an EDR or MDM.',
  },
];

export function ShippedRecently() {
  const isMobile = useIsMobile();

  return (
    <GridBand
      eyebrow="Shipped recently"
      title="Still being built, in the open."
      lede="Four of the most recent things to land across the portfolio."
      split
    >
      <YStack borderTopWidth={1} borderColor="$color3">
              {entries.map((entry, i) => (
                <XStack
                  key={entry.title}
                  flexDirection={isMobile ? 'column' : 'row'}
                  gap={isMobile ? '$2' : '$6'}
                  paddingVertical={isMobile ? '$4' : '$5'}
                  borderBottomWidth={1}
                  borderColor="$color3"
                  alignItems={isMobile ? 'flex-start' : 'baseline'}
                  hoverStyle={{ backgroundColor: '$color2' }}
                >
                  <XStack gap="$3" minWidth={isMobile ? undefined : 190} alignItems="baseline">
                    <Text fontSize="$2" color="$amber7" letterSpacing={0.6} minWidth={72}>
                      {entry.date}
                    </Text>
                    <Text
                      fontSize="$1"
                      color="$color7"
                      textTransform="uppercase"
                      letterSpacing={1.2}
                    >
                      {entry.product}
                    </Text>
                  </XStack>

                  <YStack gap="$2" flex={1}>
                    <Text fontSize={isMobile ? '$5' : '$6'} fontWeight="600" color="$color11">
                      {entry.title}
                    </Text>
                    <Text fontSize="$3" color="$color8" lineHeight={22} maxWidth={620}>
                      {entry.body}
                    </Text>
                  </YStack>
                </XStack>
              ))}
      </YStack>
    </GridBand>
  );
}
